import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import api, { UserProfileDto } from "../../../api";
import { PaginatedDataGrid, PaginationData } from "../../controls";

export interface UsersGridProps {
  onRowSelected: (row: UserProfileDto | null) => void;
}

export const UsersGrid = (props: UsersGridProps) => {
  const { onRowSelected } = props;

  const loadData = async (page: number, size: number, sort: string): Promise<PaginationData<UserProfileDto>> => {
    return await api.user.find({ page, size, sort } as any);
  };

  const columns: GridColDef<UserProfileDto>[] = [
    { field: "email", headerName: "Email", minWidth: 200, flex: 400, editable: false, sortable: true, filterable: false },
    { field: "role", headerName: "Role", width: 80, editable: false, sortable: true, filterable: true, align: "center" },
    { field: "isEnabled", headerName: "Enabled", width: 80, editable: false, sortable: true, filterable: true, align: "center", valueFormatter: (p) => (p.value ? "Yes" : "No") },
    { field: "createdAt", headerName: "Created", width: 150, editable: false, sortable: true, filterable: true, valueFormatter: (p) => dayjs(p.value).format("YYYY-MM-DD HH:mm:ss") },
  ];

  return <PaginatedDataGrid loadData={loadData} columns={columns} onRowSelected={onRowSelected} />;
};
